import React, { useState, useContext, useEffect } from "react";
import Mapir from "mapir-react-component";
import $ from "jquery";

import { DataContext } from "../../context/data-context";
import { MainContext } from "../../context/main-context";

import data from "../../data/backend_data";
import itemsIcons from "../../data/itemsIcons";
import MpIcon from "../utils/MpIcons";
import Brt from "./../../assets/mp-brt-icon.svg";
import axios from "axios";

const mapIr = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      // method:'POST',
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImMzYmU1OWY2NTBhZjRjNGE4YTNjZmQ3NTRkNWNjMWYwMTdlMDU2NjNmYjJiNjJmNzc0NWM2NjYxNzQ2ODIwY2JjY2MwYTk1ZGQ4ODQyZmE5In0.eyJhdWQiOiIyODU4NyIsImp0aSI6ImMzYmU1OWY2NTBhZjRjNGE4YTNjZmQ3NTRkNWNjMWYwMTdlMDU2NjNmYjJiNjJmNzc0NWM2NjYxNzQ2ODIwY2JjY2MwYTk1ZGQ4ODQyZmE5IiwiaWF0IjoxNzI0OTE3MjczLCJuYmYiOjE3MjQ5MTcyNzMsImV4cCI6MTcyNzUwOTI3Mywic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.tSI8OfoDCbeNAaKxwaziQH2ap7q5Qc0rbX3TagPu4Jq0mTBL8d33zP1OLpTyJrjH7ePwEkx5OpSKDXMQKgnyhDkdZamyVXhuPqSHvVMpVZMdu3jq95aC_73GfYi-A-LY_dnc7jQLfPligLFL_iKU2FgDvJBmjgzzYyDfl85AjINPNpMMw7btcRqIIiACfmpELU9HW0oekBnL2dxZ_MYfGBTkRuHtG-9Ei-vU-FquN9ddw9Lt5gN9ZrDgut1LgGmshYjizQrJ5X1neVl7qOr2N24_WmJsOKjAJFbwru4NrX06zJBJPJsz65BtnbBsIdd3m31kEwjY950j7UMgmymqDQ", //Mapir api key
        "Mapir-SDK": "reactjs",
      },
    };
  },
});

const Mapp = () => {
  const [$filter] = useState("province eq تهران");

  const [results, setResults] = useState([]);

  const [center, setCenter] = useState([51.33806228911658, 35.6997848215501]);

  const [popUpCor, setPopUpCor] = useState([]);

  const [address, setAddress] = useState("");

  const [zoom, setZoom] = useState([11]);


  const dataContext = useContext(DataContext);
  const mainContext = useContext(MainContext);

  const back_data = data;

  const mainData = mainContext.mainContent;

  const icon = $.isEmptyObject(mainData)
    ? {
        // default icon
        id: 201,
        icon: <MpIcon name="brt" size="sm" />,
        img: Brt,
        color: "#1874E7",
      }
    : itemsIcons.find((value) => value.id === mainData.id);


  // generate random color for buslines
  const getRandomColor = () => {
    var letters = "123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const busLinesMapir =
    mainContext.busLinesData != null && mainContext.busLineDataIsShow
      ? mainContext.busLinesData.value.map((val, index) => (
          <Mapir.GeoJSONLayer
            key={index}
            type="line"
            data={{
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  properties: {},
                  geometry: {
                    type: `${val.coor.type}`,
                    coordinates: val.coor.coordinates,
                  },
                },
              ],
            }}
            linePaint={{
              "line-color": `${
                !mainContext.busLineDataIsShow ? "#ffffff" : "#010101"
              }`,
              "line-width": 2,
            }}
            style={{ border: "2px solid red" }}
          />
        ))
      : null;
  const selectedPin =
    popUpCor[0] == undefined ? null : (
      <Mapir.Marker
        className="m-selectedPin"
        coordinates={[popUpCor[0], popUpCor[1]]}
        anchor="bottom"
      />
    );

  const markers = $.isEmptyObject(mainData)
    ? null
    : mainData.id == 201
    ? null
    : mainData.id == 203
    ? null
    : mainData.value.map((val, index) => (
        <Mapir.Marker
          key={index}
          // coordinates={[val.lat, val.lon]}
          coordinates={[val.lon, val.lat]}
          anchor="bottom"
          Image={icon.img}
          style={{
            display: !mainContext.showMainPanel ? "none" : null,
            backgroundColor: `${icon.color}`,
            width: "22px",
            height: "22px",
            borderRadius: "3px",
            transform: "scale(.55)",
          }}
        />
      ));
  const AccordionClickHandler = (id) => {
    // checking if cat data is empty or not
    if (id == 200) gettigDataCat(["per", dataContext.SetDataCat200]);
    else if (id == 300) gettigDataCat(["pub", dataContext.SetDataCat300]);
    else if (id == 400) gettigDataCat(["ref", dataContext.SetDataCat400]);
    else if (id == 500) gettigDataCat(["sec", dataContext.SetDataCat500]);
  };
  const gettigDataCat = (input) => {
    // real request syntax :
    if (true) {
      const params = new URLSearchParams();
      const [lng, lat] = dataContext.clickedPointData.data.geom.coordinates;
      //lng and lat are string should convert to num
      params.append("lat", +lat);
      params.append("lon", +lng);
      // sec //per //pub //ref
      axios
        .post(`https://mahalino.sedrehgroup.ir/api/${input[0]}`, params)
        .then((res) => {
          input[1](res.data);
        })

        .catch((err) => console.log(err));
    }
  };
  const reverseFunction = (map, e) => {
    const lat = e.lngLat.lat;
    const lng = e.lngLat.lng;

    var url = `https://map.ir/reverse/no?lat=${lat}&lon=${lng}`;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImMzYmU1OWY2NTBhZjRjNGE4YTNjZmQ3NTRkNWNjMWYwMTdlMDU2NjNmYjJiNjJmNzc0NWM2NjYxNzQ2ODIwY2JjY2MwYTk1ZGQ4ODQyZmE5In0.eyJhdWQiOiIyODU4NyIsImp0aSI6ImMzYmU1OWY2NTBhZjRjNGE4YTNjZmQ3NTRkNWNjMWYwMTdlMDU2NjNmYjJiNjJmNzc0NWM2NjYxNzQ2ODIwY2JjY2MwYTk1ZGQ4ODQyZmE5IiwiaWF0IjoxNzI0OTE3MjczLCJuYmYiOjE3MjQ5MTcyNzMsImV4cCI6MTcyNzUwOTI3Mywic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.tSI8OfoDCbeNAaKxwaziQH2ap7q5Qc0rbX3TagPu4Jq0mTBL8d33zP1OLpTyJrjH7ePwEkx5OpSKDXMQKgnyhDkdZamyVXhuPqSHvVMpVZMdu3jq95aC_73GfYi-A-LY_dnc7jQLfPligLFL_iKU2FgDvJBmjgzzYyDfl85AjINPNpMMw7btcRqIIiACfmpELU9HW0oekBnL2dxZ_MYfGBTkRuHtG-9Ei-vU-FquN9ddw9Lt5gN9ZrDgut1LgGmshYjizQrJ5X1neVl7qOr2N24_WmJsOKjAJFbwru4NrX06zJBJPJsz65BtnbBsIdd3m31kEwjY950j7UMgmymqDQ", //Mapir api key,
        },
      })
      .then((res) => {
        dataContext.SetClickedPointData(res);
      })
      .catch((e) => console.error(e));

    setPopUpCor([lng, lat]);
    setCenter([lng, lat]);
    dataContext.SetData(back_data);

    mainContext.toggleShowFirstCat(false);

    mainContext.toggleShowMainPanel(false);
  };
  const func = () => {
    AccordionClickHandler(dataContext.openedCat);
    if (dataContext.clickedPointDataOld != dataContext.clickedPointData) {
      mainContext.toggleBusLineDataShow(false);
    }
  };
  return (
    <>
      <div className="wrapper" onClick={func}>
        <Mapir
          className="mapir"
          containerStyle={{}}
          center={[center[0], center[1] + 0.015]}
          scrollZoom={true}
          hash={true}
          attributionControl={true}
          dragpan={true}
          // interactive={true}
          Map={mapIr}
          onClick={reverseFunction}
        >
          {busLinesMapir}

          {selectedPin}
          {markers}
        </Mapir>
      </div>
    </>
  );
};
let _Map;
export default _Map = React.memo(Mapp);
